import { render, staticRenderFns } from "./AlgorithmParameters.vue?vue&type=template&id=137aa796&scoped=true&lang=html&"
import script from "./AlgorithmParameters.vue?vue&type=script&lang=js&"
export * from "./AlgorithmParameters.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmParameters.vue?vue&type=style&index=0&id=137aa796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137aa796",
  null
  
)

export default component.exports